import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { api } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";

export default function Profile() {
  const { user } = useAuth();
  const [pwd, setPwd] = useState({ current_password: "", new_password: "" });

  const changePassword = async () => {
    try { await api.post("/auth/change-password", pwd); toast.success("Password updated"); setPwd({ current_password: "", new_password: "" }); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-4 sm:space-y-6" data-testid="sales-profile">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-black">My profile</h1>
        <p className="text-muted-foreground">Personal details, password and preferences.</p>
      </div>
      <Card>
        <CardHeader><CardTitle>Personal details</CardTitle></CardHeader>
        <CardContent className="space-y-2 text-sm">
          <div className="flex justify-between"><span className="text-muted-foreground">Name</span><span className="font-semibold">{user?.full_name}</span></div>
          <div className="flex justify-between"><span className="text-muted-foreground">Email</span><span>{user?.email}</span></div>
          <div className="flex justify-between"><span className="text-muted-foreground">Role</span><Badge>{user?.role}</Badge></div>
          <div className="flex justify-between"><span className="text-muted-foreground">MFA</span>{user?.mfa_enabled ? <Badge>Enabled</Badge> : <Badge variant="outline">Disabled — enable from Security</Badge>}</div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader><CardTitle>Change password</CardTitle></CardHeader>
        <CardContent className="space-y-3 max-w-md">
          <div><Label>Current password</Label><Input type="password" value={pwd.current_password} onChange={(e) => setPwd({ ...pwd, current_password: e.target.value })} data-testid="pwd-current" /></div>
          <div><Label>New password</Label><Input type="password" value={pwd.new_password} onChange={(e) => setPwd({ ...pwd, new_password: e.target.value })} data-testid="pwd-new" /></div>
          <Button onClick={changePassword} disabled={!pwd.current_password || !pwd.new_password} data-testid="pwd-save">Update password</Button>
        </CardContent>
      </Card>
    </div>
  );
}
